import {Component, ViewChild} from "@angular/core"; import { Location } from "@angular/common";
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';
import { EmployeEntite } from '../entites/employe';
import { DonneesBaseService } from '../services/donnees-base-service';
import { Fournisseur } from '../entites/fournisseur';
import { BaseComponent } from '../base/base-component';
import { ProfilService } from '../services/profil-service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppMainComponent } from '../app.main.component';
import { FournisseurService } from '../services/fournisseur-service';
import { PrixFournisseurEntite } from '../entites/prix-fournisseur';
import { EntretienPreventifEntite } from '../entites/mecanique/entretien-preventif';


@Component({
    templateUrl: './consulter-pieces.component.html',
})
export class ConsulterPiecesComponent extends BaseComponent {

    entretien: EntretienPreventifEntite;
    
    constructor(
        sdb: DonneesBaseService,
        profilService: ProfilService,
        route: ActivatedRoute, 
        routerService: Router,
        appMain: AppMainComponent, location: Location, 
        private fournisseurService: FournisseurService,
        public ref: DynamicDialogRef, 
        public config: DynamicDialogConfig) {

            super(sdb, profilService, route, routerService, appMain); }

    ngOnInit() {

        this.entretien = this.config.data;

        this.CompleterChargement();

    }

    surEntree() {
        this.ref.close(null);
    }

    selectionner(prix: PrixFournisseurEntite) {
      this.ref.close(prix);
    }

    commander(prix: PrixFournisseurEntite) {
        this.ref.close(prix);
      }

    annuler() {
        this.ref.close(null);
    }
}